import LoadingButton from '@mui/lab/LoadingButton';
import { Typography, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import T from 'prop-types';

const AlertModal = ({ onClick = null, title, children, okText, modal }) => {
  const handleCloseModal = () => {
    if (typeof onClick !== 'function') {
      modal.closeModal();
      return;
    }
    onClick();
  };
  return (
    <>
      {title && (
        <DialogTitle sx={{ pt: 3, pb: 1 }} align={'center'}>
          <>{title ? <Typography variant="h4">{title}</Typography> : null}</>
        </DialogTitle>
      )}
      <DialogContent sx={{ pb: 3, pt: 0, overflow: 'hidden' }} align="center">
        {children}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, pt: 0 }}>
        <LoadingButton variant="contained" fullWidth onClick={handleCloseModal}>
          {okText}
        </LoadingButton>
      </DialogActions>
    </>
  );
};

AlertModal.propTypes = {
  okText: T.string,
  title: T.string,
  onClose: T.func.isRequired,
  titleAlign: T.string,
  children: T.any,
  loading: T.bool,
};

AlertModal.defaultProps = {
  title: '',
  loading: false,
  okText: 'Ok',
  children: '',
  titleAlign: 'center',
  onClose: () => {},
};

export default AlertModal;
